// var $baseUrl = "https://apidev.anyforprint.com"; //开发环境 默认地址


var $baseUrl = "https://api.anyforprint.com"; //正式环境 默认地址

export default {
  $baseUrl
}



//////////////////
// WEBPACK FOOTER
// ./static/config.js
// module id = null
// module chunks = 